import Api from "../Api";
import { ListRequestPayload } from "./types";

export async function fetchUserData() {
    return await Api().get("/user");
}
export async function updateProfile(formData) {
    return await Api().post("/auth/update-profile", formData);
}

export async function updateAgencyProfile(formData) {
    return await Api().post("/auth/update-agency-profile", formData);
}

export async function getAgencyProfile() {
    return await Api().get("/auth/get-agency-profile");
}

export async function checkUsername(formData) {
    return await Api().post("/auth/check-username", formData);
}

export async function updatePassword(formData) {
    return await Api().post("/auth/password-change", formData);
}

export async function updateSitePassword(formData) {
    return await Api().post("/auth/site-password-change", formData);
}

export async function deleteAgencyProfile(formData) {
    return await Api().post("/auth/delete-agency-account", formData);
}

export async function getAgencies() {
    return await Api().get("/get-agencies");
}

export async function getAgencyUsers(payload: ListRequestPayload) {
    return await Api().get(
        "/auth/list-users?page=" +
        payload.page +
        "&filter=" +
        payload.filter +
        "&perPage=" +
        payload.perPage,
    );
}
export async function addAgencyUsers(formData) {
    return await Api().post("/auth/add-user", formData);
}

export async function getUserById(userId) {
    return await Api().get("/auth/get-user-by-id/" + userId);
}

export async function deleteAgencyUser(formData) {
    return await Api().post("/auth/delete-agency-user", formData);
}

export async function fetchAgencyUsages() {
    return await Api().post("/auth/agency-usages");
}
export async function purgeCloudflareCache() {
    return await Api().post("/purge-cache");
}
export async function cacheClear() {
    return await Api().post("/clear-cache");
}
export async function allCacheClear() {
    return await Api().post("/clear-all-cache");
}

export async function checkSubdomain(formData) {
    return await Api().post("/auth/check-subdomain", formData);
}

export async function storeUserAgency(formData) {
    return await Api().post("/travel/agency", formData);
}

export async function storeWebsiteInfo(formData) {
    return await Api().post("/travel/agency-website", formData);
}

export async function storeAgencyAddress(formData) {
    return await Api().post("/travel/agency-address", formData);
}

export async function getCurrentCountry(ip) {
    return await Api().get("/auth/current-country?ip=" + ip);
}

export async function getCurrentLanguage() {
    return await Api().get("/auth/current-language");
}

export async function storeCurrentLanguage(formData) {
    return await Api().post("/auth/store-language", formData);
}

export async function getTranslationText(translated_page, untranslated_page, filter) {
    return await Api().get("/auth/translation-text?translated_page=" + translated_page + "&untranslated_page=" + untranslated_page + "&perPage=" + filter.perPage + "&search=" + filter.search);
}

export async function storeTranslation(formData) {
    return await Api().post("/auth/store-translation", formData);
}

export async function storeOnboarding() {
    return await Api().post("/auth/store-onboarding");
}

export async function toggleSitePassword(payload) {
    return await Api().post("/toggle-site-password", payload);
}

export async function checkSmtpConfig() {
    return await Api().get("/email-settings/check-smtp-config");
}
